<template>
    <span class="text-danger" v-if="mostrarBtnExcluir">
        <i
            class="fa fa-trash fa-lg icon-button ml-1"
            title="Excluir comprometimento"
            @click.stop="confirmarExcluir()"
        ></i>
    </span>
</template>

<script>
import { StatusComprometimento } from '../etapas/StatusComprometimento'

export default {
    props: {
        despesa: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            required: true,
            default: () => ({})
        },

        permiteExcluir: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Exclusão de Comprometimento',
                html: `Confirma a exclusão do comprometimento de ID <b>${this.despesa.idMov}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            this.servicos
                .excluirComprometimento(this.despesa.etapaId, this.despesa.despesaId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('recarregarDespesas')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir comprometimento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnExcluir() {
            return (
                this.permiteExcluir && 
                this.despesa.statusIdMov != 'F' &&
                (this.despesa.statusComprometimento ==
                    StatusComprometimento.COMPROMETIDO ||
                this.despesa.statusComprometimento ===
                    StatusComprometimento.ATUALIZAR_COMPROMETIMENTO ||
                    (this.despesa.statusComprometimento ==
                        StatusComprometimento.ERRO &&
                    this.despesa.idMov
                    )
                )
            )
        }
    }
}
</script>
